import PropTypes from 'prop-types';

import ALink from 'tradera/components/alink/alink';
import styles from './dropdown-menu.module.scss';
import ArrowRightIcon from '@tradera/blueprint/theme/icons2/arrow-right.svg?jsx';
import { classNames } from 'tradera/utils/class-names';

const MenuItemButton = ({
    className = '',
    containerClass = styles.itemDefault,
    follow = true,
    gaAttributes,
    inSPA,
    label,
    link,
    onClick,
}) => {
    return (
        <li>
            <ALink
                className={classNames(
                    'font-weight-bold d-flex align-items-center justify-content-between font-hansen',
                    className,
                    containerClass,
                )}
                href={link}
                useLink={inSPA}
                onClick={onClick}
                {...(!follow && { rel: 'nofollow' })}
                {...gaAttributes}>
                <span className="pl-5">{label}</span>
                <ArrowRightIcon className="icon icon-sm mr-2" />
            </ALink>
        </li>
    );
};

MenuItemButton.propTypes = {
    notify: PropTypes.number,
    link: PropTypes.string,
    bold: PropTypes.bool,
    border: PropTypes.bool,
    label: PropTypes.node,
    gaAttributes: PropTypes.object,
};

export default MenuItemButton;
